import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductsByKeyword } from "../features/product/productActions";
import SearchItemImg from "../assets/images/search-itme.png";

const NAV_ITEMS = [
  {
    to: "/",
    activePath: "/",
    label: "Home",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.5 6.5C2.5 4.29086 4.29086 2.5 6.5 2.5C8.70914 2.5 10.5 4.29086 10.5 6.5V9.16667C10.5 9.47666 10.5 9.63165 10.4659 9.75882C10.3735 10.1039 10.1039 10.3735 9.75882 10.4659C9.63165 10.5 9.47666 10.5 9.16667 10.5H6.5C4.29086 10.5 2.5 8.70914 2.5 6.5Z"
          strokeWidth="1.5"
        />
        <path
          d="M13.5 14.8333C13.5 14.5233 13.5 14.3683 13.5341 14.2412C13.6265 13.8961 13.8961 13.6265 14.2412 13.5341C14.3683 13.5 14.5233 13.5 14.8333 13.5H17.5C19.7091 13.5 21.5 15.2909 21.5 17.5C21.5 19.7091 19.7091 21.5 17.5 21.5C15.2909 21.5 13.5 19.7091 13.5 17.5V14.8333Z"
          strokeWidth="1.5"
        />
        <path
          d="M2.5 17.5C2.5 15.2909 4.29086 13.5 6.5 13.5H8.9C9.46005 13.5 9.74008 13.5 9.95399 13.609C10.1422 13.7049 10.2951 13.8578 10.391 14.046C10.5 14.2599 10.5 14.5399 10.5 15.1V17.5C10.5 19.7091 8.70914 21.5 6.5 21.5C4.29086 21.5 2.5 19.7091 2.5 17.5Z"
          strokeWidth="1.5"
        />
        <path
          d="M13.5 6.5C13.5 4.29086 15.2909 2.5 17.5 2.5C19.7091 2.5 21.5 4.29086 21.5 6.5C21.5 8.70914 19.7091 10.5 17.5 10.5H14.6429C14.5102 10.5 14.4438 10.5 14.388 10.4937C13.9244 10.4415 13.5585 10.0756 13.5063 9.61196C13.5 9.55616 13.5 9.48982 13.5 9.35714V6.5Z"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    to: "",
    activePath: "",
    label: "Explore",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="11.5" cy="11.5" r="9.5" strokeWidth="1.5" />
        <path d="M18.5 18.5L22 22" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    to: "/profile/my-orders",
    activePath: "/profile/my-orders",
    label: "Orders",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5777 3.38197L17.5777 4.43152C19.7294 5.56066 20.8052 6.12523 21.4026 7.13974C22 8.15425 22 9.41667 22 11.9415V12.0585C22 14.5833 22 15.8458 21.4026 16.8603C20.8052 17.8748 19.7294 18.4393 17.5777 19.5685L15.5777 20.618C13.8221 21.5393 12.9443 22 12 22C11.0557 22 10.1779 21.5393 8.42229 20.618L6.42229 19.5685C4.27063 18.4393 3.19479 17.8748 2.5974 16.8603C2 15.8458 2 14.5833 2 12.0585V11.9415C2 9.41667 2 8.15425 2.5974 7.13974C3.19479 6.12523 4.27063 5.56066 6.42229 4.43152L8.42229 3.38197C10.1779 2.46066 11.0557 2 12 2C12.9443 2 13.8221 2.46066 15.5777 3.38197Z"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M21 7.5L17 9.5M12 12L3 7.5M12 12V21.5M12 12C12 12 14.7426 10.6287 16.5 9.75C16.6953 9.65237 17 9.5 17 9.5M17 9.5V13M17 9.5L7.5 4.5"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  {
    to: "/cart",
    activePath: "/cart",
    label: "Cart",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 3L2.26491 3.0883C3.58495 3.52832 4.24497 3.74832 4.62248 4.2721C5 4.79587 5 5.49159 5 6.88304V9.5C5 12.3284 5 13.7426 5.87868 14.6213C6.75736 15.5 8.17157 15.5 11 15.5H19"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z"
          strokeWidth="1.5"
        />
        <path
          d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z"
          strokeWidth="1.5"
        />
        <path d="M11 9H8" strokeWidth="1.5" strokeLinecap="round" />
        <path
          d="M5 6H16.4504C18.5054 6 19.5328 6 19.9775 6.67426C20.4221 7.34853 20.0173 8.29294 19.2078 10.1818L18.7792 11.1818C18.4013 12.0636 18.2123 12.5045 17.8366 12.7523C17.4609 13 16.9812 13 16.0218 13H5"
          strokeWidth="1.5"
        />
      </svg>
    ),
  },
  {
    to: "/profile",
    activePath: "/profile",
    label: "Profile",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="9" r="3" strokeWidth="1.5" />
        <circle cx="12" cy="12" r="10" strokeWidth="1.5" />
        <path
          d="M17.9692 20C17.8101 17.1085 16.9248 15 12 15C7.07527 15 6.18997 17.1085 6.03082 20"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
];

function BottomNav() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { searchProducts } = useSelector((state) => state.product);
  const { cart } = useSelector((state) => state.cart);
  const [showSearch, setShowSearch] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const [addedToCart, setAddedToCart] = useState(false);

  const handleSearchChange = (e) => {
    const keyword = e.target.value;
    setQuery(keyword);

    if (keyword.trim() !== "") {
      dispatch(fetchProductsByKeyword({ page: 1, limit: 25, keyword }));
    }
  };

  const closeSearch = () => {
    setShowSearch(false);
    setQuery("");
  };
  const handleBottomNavLinkClick = () => {
    closeSearch();
    if (window.innerWidth <= 767) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  };
  const isProductDetails = location.pathname.startsWith("/products/");
  const isCart = location.pathname === "/cart";
  const isCheckout = location.pathname === "/cart/checkout";
  const isOrdersRoute =
    location.pathname === "/profile/my-orders" ||
    location.pathname === "/profile/return-orders";

  if (isCart || isCheckout) return null;
  const productSlug = location.pathname.split("/products/")[1];
  const isInCart = productSlug
  ? cart?.some(
      (item) => item.slug === productSlug || item.product?.slug === productSlug
    )
  : false;

  if (isProductDetails) {
    const handleMobileAddToCart = () => {
      if (isInCart) {
        navigate("/cart");
      } else {
        window.dispatchEvent(new CustomEvent("mobile-add-to-cart"));
        setAddedToCart(true);
      }
    };

    return (
      <nav className="bottom-nav bottom-nav--add-to-cart">
        <button
          type="button"
          className="continue-shopping-bar"
          onClick={() => navigate('/products')}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 12H4M10 18L4 12L10 6"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <button
          type="button"
          className="add-to-cart-bar"
          onClick={handleMobileAddToCart}
        >
          {isInCart ? (
            <>
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 3L2.26491 3.0883C3.58495 3.52832 4.24497 3.74832 4.62248 4.2721C5 4.79587 5 5.49159 5 6.88304V9.5C5 12.3284 5 13.7426 5.87868 14.6213C6.75736 15.5 8.17157 15.5 11 15.5H19"
                  stroke="#fff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z"
                  stroke="#fff"
                  strokeWidth="1.5"
                />
                <path
                  d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z"
                  stroke="#fff"
                  strokeWidth="1.5"
                />
                <path
                  d="M11 9H8"
                  stroke="#fff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M5 6H16.4504C18.5054 6 19.5328 6 19.9775 6.67426C20.4221 7.34853 20.0173 8.29294 19.2078 10.1818L18.7792 11.1818C18.4013 12.0636 18.2123 12.5045 17.8366 12.7523C17.4609 13 16.9812 13 16.0218 13H5"
                  stroke="#fff"
                  strokeWidth="1.5"
                />
              </svg>
              View Cart
            </>
          ) : (
            <>
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 3L2.26491 3.0883C3.58495 3.52832 4.24497 3.74832 4.62248 4.2721C5 4.79587 5 5.49159 5 6.88304V9.5C5 12.3284 5 13.7426 5.87868 14.6213C6.75736 15.5 8.17157 15.5 11 15.5H19"
                  stroke="#fff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z"
                  stroke="#fff"
                  strokeWidth="1.5"
                />
                <path
                  d="M16.5 18.0001C17.3284 18.0001 18 18.6716 18 19.5001C18 20.3285 17.3284 21.0001 16.5 21.0001C15.6716 21.0001 15 20.3285 15 19.5001C15 18.6716 15.6716 18.0001 16.5 18.0001Z"
                  stroke="#fff"
                  strokeWidth="1.5"
                />
                <path
                  d="M11 9H8"
                  stroke="#fff"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M5 6H16.4504C18.5054 6 19.5328 6 19.9775 6.67426C20.4221 7.34853 20.0173 8.29294 19.2078 10.1818L18.7792 11.1818C18.4013 12.0636 18.2123 12.5045 17.8366 12.7523C17.4609 13 16.9812 13 16.0218 13H5"
                  stroke="#fff"
                  strokeWidth="1.5"
                />
              </svg>
              Add to Cart
            </>
          )}
        </button>
      </nav>
    );
  }

  return (
    <>
      <nav className="bottom-nav">
        {NAV_ITEMS.map((item, i) => {
          const isExplore = item.label === "Explore";
          let isActive;
          if (isExplore) {
            isActive = showSearch || location.pathname === "/product";
          } else if (item.label === "Orders") {
            isActive = !showSearch && isOrdersRoute;
          } else if (item.label === "Profile") {
            isActive =
              !showSearch && location.pathname === "/profile" && !isOrdersRoute;
          } else {
            isActive = !showSearch && location.pathname === item.activePath;
          }

          if (isExplore) {
            return (
              <button
                key={i}
                type="button"
                onClick={() => setShowSearch(true)}
                className={`bottom-nav-item${isActive ? " active" : ""}`}
              >
                {item.icon}
                <span>{item.label}</span>
              </button>
            );
          }
          return (
            <Link
              key={i}
              to={item.to}
              className={`bottom-nav-item${isActive ? " active" : ""}`}
              onClick={handleBottomNavLinkClick}
            >
              {item.label === "Cart" ? (
                <span className="bottom-nav-cart-icon-wrap">
                  {item.icon}
                  {cart?.length > 0 && (
                    <span className="bottom-nav-cart-count">{cart.length}</span>
                  )}
                </span>
              ) : (
                item.icon
              )}
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <Offcanvas
        show={showSearch}
        onHide={closeSearch}
        placement="end"
        className="mobile-search-offcanvas"
      >
        <div className="mso-header">
          <button type="button" className="mso-back" onClick={closeSearch}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 12H4M10 18L4 12L10 6"
                stroke="#00A991"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <div className="mso-input-wrap">
            <input
              type="text"
              className="mso-input"
              placeholder="Search"
              value={query}
              onChange={handleSearchChange}
            />
          </div>
          {query ? (
            <button
              type="button"
              className="mso-clear"
              onClick={() => setQuery("")}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="#DC1839"
                  strokeWidth="1.5"
                />
                <path
                  d="M14.5 9.5L9.5 14.5M9.49998 9.49998L14.5 14.5"
                  stroke="#DC1839"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          ) : (
            <span className="mso-clear-placeholder" />
          )}
        </div>

        <div className="mso-body">
          {/* <p className="mso-label">{query ? 'Search Result' : 'Recent Search'}</p> */}
          <ul className="mso-list">
            {query ? (
              searchProducts && searchProducts.length > 0 ? (
                searchProducts.map((product) => (
                  <li key={product.id}>
                    <Link
                      to={`/products/${product.slug}`}
                      className="mso-item"
                      onClick={closeSearch}
                    >
                      <div className="mso-item-img">
                        <img
                          src={
                            product.image
                              ? `${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${product.image}`
                              : SearchItemImg
                          }
                          alt={product.title}
                        />
                      </div>
                      <div className="mso-item-text">
                        <h4>{product.title}</h4>
                        <p>
                          {product.short_description ||
                            "No description available."}
                        </p>
                      </div>
                    </Link>
                  </li>
                ))
              ) : (
                <li>No products found</li>
              )
            ) : (
              <li>Type to search products</li>
            )}
          </ul>
        </div>
      </Offcanvas>
    </>
  );
}

export default BottomNav;
